import { useId } from '@floating-ui/react';

export default function useUniqueId(customId?: string) {
  const id = useId();

  return customId || id;
}
